function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailedParentOrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Parent organization icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 15.401 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Parent organization logo",
    d: "M7.283 20.6A1.278 1.278 0 0 1 6 19.317V9.948a1.278 1.278 0 0 1 1.283-1.284h4V7.231a1.559 1.559 0 0 1 .021-.257.982.982 0 0 1 .075-.246 1.4 1.4 0 0 1 .128-.225 1.435 1.435 0 0 1 .16-.193l1.583-1.54a.675.675 0 0 1 .9 0l1.583 1.54a1.072 1.072 0 0 1 .289.417 1.369 1.369 0 0 1 .1.5v4.984h4A1.278 1.278 0 0 1 21.4 13.5v5.818a1.278 1.278 0 0 1-1.282 1.282zm0-1.283h2.268v-2.268H7.283zm0-3.551h2.268V13.5H7.283zm0-3.551h2.268V9.948H7.283zm5.283 7.1h2.267v-2.266h-2.266zm0-3.551h2.267V13.5h-2.266zm0-3.551h2.267V9.948h-2.266zm0-3.551h2.267V6.4h-2.266zm5.284 10.655h2.267v-2.268H17.85zm0-3.551h2.267V13.5H17.85z",
    transform: "translate(-6 -4.6)",
    style: {
      fill: "#0F1177"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailedParentOrg);
export default __webpack_public_path__ + "static/media/detailed-parent-org.2d30cdb26825deadd699770790c04877.svg";
export { ForwardRef as ReactComponent };